import { Injectable } from "@angular/core";
import { LgApplicationPermissionsBase } from "@logex/framework/lg-application";

@Injectable({ providedIn: "root" })
export class AppPermisions extends LgApplicationPermissionsBase {
    static readonly readOrganisations = "organization_read";
    static readonly editOrganisations = "organization_write";
    static readonly definitions = "definitions_read";
    static readonly admin = "organization_admin";
}
